import { Dimmer } from 'semantic-ui-react';
import { PropTypes } from 'prop-types';
import React from 'react';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import {
  CancelButton,
  ButtonContainer,
  Container,
  ContentContainer,
  Dialog,
  ConfirmButton,
  Text,
} from './styles';

const ModalConfirm = (props) => {
  const {
    show,
    error,
    isLoading,
    onConfirm,
    textConfirm,
    textCancel,
    textContent,
    defaultMessage,
    onCancel,
  } = props;

  const auxError = {};
  const revealError = error && error.message.includes('already exists');
  if (revealError) {
    const messageArray = error.message.split('Name ');
    auxError.message = messageArray[messageArray.length - 1];
  }

  return (
    <Dimmer active={show} onClickOutside={onCancel} page>
      <Dialog>
        <Container>
          <ContentContainer>
            <Text>
              {textContent}
            </Text>

            {error && (
              <ErrorHandler
                error={auxError}
                defaultMessage={defaultMessage}
                revealError={revealError}
              />
            )}
          </ContentContainer>

          <ButtonContainer>
            <CancelButton
              disabled={isLoading}
              onClick={onCancel}
            >
              {textCancel}
            </CancelButton>

            <ConfirmButton
              loading={isLoading}
              onClick={onConfirm}
            >
              {textConfirm}
            </ConfirmButton>
          </ButtonContainer>

        </Container>
      </Dialog>
    </Dimmer>
  );
};

ModalConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  textConfirm: PropTypes.string.isRequired,
  textCancel: PropTypes.string.isRequired,
  textContent: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string,
};

ModalConfirm.defaultProps = {
  error: null,
  defaultMessage: 'Something went wrong!',
};

export default ModalConfirm;
